<template>
    <div>
        <div class="flex justify-between">
            <div :class="{ 'text-gray-400': number === 0 }" v-if="displayCurrent">{{ number }}</div>

            <div class="flex justify-between space-x-2">
                <button
                    type="button"
                    @click="decrease()"
                    :class="canDecrease ? 'text-indigo-500' : 'text-gray-300'"
                    :disabled="!canDecrease"
                >
                    <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                </button>

                <button @click="increase()" :disabled="!canIncrease" type="button">
                    <svg
                        class="w-6 h-6"
                        :class="canIncrease ? 'text-indigo-500' : 'text-gray-300'"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';

let emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {},
    min: {
        type: Number,
        required: true,
    },
    max: {
        type: Number,
        required: true,
    },
    displayCurrent: {
        type: Boolean,
        default: true,
    },
});

let number = ref(props.modelValue);
watch(number, (newVal) => emit('update:modelValue', newVal));

const canDecrease = computed(() => number.value > props.min);
function decrease() {
    if (canDecrease.value) {
        number.value--;
    }
}

const canIncrease = computed(() => number.value < props.max);
function increase() {
    if (canIncrease.value) {
        number.value++;
    }
}
</script>
